import { BePlannedPage } from "./BePlanned";

export default BePlannedPage;
